var map = {
	"./a-gradient.svg": 5104,
	"./a-white.svg": 5121,
	"./academic.svg": 5778,
	"./bg-research_group.svg": 673,
	"./bg-user-verified.jpg": 8721,
	"./centre.svg": 8527,
	"./close-white.svg": 2228,
	"./community.svg": 4694,
	"./dashboard.svg": 5307,
	"./desk-open.svg": 4550,
	"./email.svg": 9815,
	"./empty-page.svg": 1686,
	"./enago.png": 5257,
	"./google-drive.png": 5346,
	"./group-illustration.svg": 1789,
	"./icon/affiliation_at_time_of_writing.svg": 8608,
	"./icon/compare_list.svg": 3708,
	"./icon/incubator.svg": 4923,
	"./icon/network.svg": 8618,
	"./icon/notifications.svg": 8949,
	"./icon/open_access.svg": 4703,
	"./landscape/landscape_list.svg": 2950,
	"./landscape/landscape_us_states.svg": 446,
	"./landscape/landscape_world.svg": 9885,
	"./lightbulb.svg": 1306,
	"./login.svg": 6872,
	"./no-results.svg": 8997,
	"./organisation.svg": 4661,
	"./personal.svg": 5712,
	"./professional.svg": 8800,
	"./register.svg": 569,
	"./research_group-company.svg": 974,
	"./research_group-team.svg": 5351,
	"./resultcard_graphs_locked.svg": 95,
	"./resultcard_locked.svg": 5122,
	"./resultlist_locked.svg": 3077,
	"./signup.svg": 9022,
	"./student.svg": 9047,
	"./unverified-shield-red.svg": 390,
	"./unverified-shield-yellow.svg": 9894,
	"./unverified-shield.svg": 3551,
	"./verified-shield.svg": 8718,
	"./welcome-image.svg": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3494;